<template>
    <div class="logo-map">
        <div class="f-row">
            <Breadcrumb separator=">" class="breadcrumb_zdy">
                当前位置:
                <BreadcrumbItem :to="{name: 'SpecialList'}">专题Pro</BreadcrumbItem>
                <BreadcrumbItem>图谱</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div class="map-list">
            <div class="logo-map-title" v-if="map_detail.hide_title == '0'">
                <i class="iconfont">&#xe6e2;</i>{{map_detail.title}}
            </div>
            <div class="logo-map-summary" v-html="map_detail.summary" v-if="map_detail.summary"></div>
            <div class="logo-map-content">
                <div class="maps">
                    <div v-for="item,index in map_list" :key="item.module_id">
                        <div class="map-title">{{item.module_name}}</div>
                        <div class="logos">
                            <Tooltip
                                placement="top"
                                v-for="e_item,e_index in item.entity"
                                :key="e_index"
                                :content="e_item.short_name"
                            >
                                <span class="logo-span" @click="goEntityDetail(e_item)">
                                    <img :src="e_item.logo_path | logo_show" />
                                </span>
                            </Tooltip>

                        </div>
                    </div>
                </div>
            </div>
            <p>数据来源：<template v-if="map_detail.src">{{map_detail.src}}</template><template v-else>动脉橙产业智库</template></p>
        </div>
        <div class="spa">
            <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid)" @on-popper-hide="handleShareHide">
                <i class="iconfont">&#xe641;</i>
                <div slot="content" class="share_cnt clear">
                    <div class="share_img"></div>
                    <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                </div>
            </Poptip>
        </div>
    </div>
</template>
<script>
import { getMapById } from '../../service'
export default {
  data() {
    return {
      map_detail: '',
      map_list: []
    }
  },
  methods: {
    async getMapById() {
      let params = {
        map_id: this.$route.query.map_id,
        theme_id: this.$route.query.theme_uid
      }
      let res = await getMapById(params, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'map_detail', res.res[0])
        // console.log(this.map_detail)
        this.map_detail.content.map((a) => {
          let index = this.map_list.findIndex((b) => a.module_id === b.module_id)
          if(index === -1){
            this.map_list.push({
              module_name: a.module_name,
              module_id: a.module_id,
              pid: a.pid,
              sort_num: a.sort_num,
              entity: [
                {
                  entity_type: a.entity_type,
                  entity_main_page: a.entity_main_page,
                  entity_uid: a.entity_uid,
                  logo_path: a.logo_path,
                  short_name: a.short_name
                }
              ]
            })
          } else {
            this.map_list[index].entity.push({
              entity_type: a.entity_type,
              entity_main_page: a.entity_main_page,
              entity_uid: a.entity_uid,
              logo_path: a.logo_path,
              short_name: a.short_name
            })
          }
        })
        this.map_list.sort((a,b) => a.sort_num - b.sort_num)
        // console.log(this.map_list)
      } else {
        this.$Message.error(res.message)
      }
    },
    goEntityDetail(e_item) {
      let uid = e_item.entity_uid, 
          type = e_item.entity_type
      if(type == 0){ //公司
        const { href } = this.$router.resolve({name: "CompanyDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if(type == 1){ //机构
        const { href } = this.$router.resolve({name: "OrgDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if (type == 2) { //人物
        const { href } = this.$router.resolve({name: "PeoDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if(type == 3){ //医疗机构
        const { href } = this.$router.resolve({name: "HospitalDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if(type == 6 || type == 7 || type == 8){ //研究机构 政府机构 行业协会
        if(e_item.entity_main_page) {
          const href = e_item.entity_main_page
          window.open(href, '_blank')
        }
      }
    },
    handleShare(theme_uid) {
      let share_link = window.location.protocol + '//' + window.location.host + '/mindex/shareMap/'+this.$route.query.map_id+'?theme_uid=' + this.$route.query.theme_uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    }
  },
  created() {
    this.getMapById()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.logo-map
  width: 1016px
  padding: 16px 0 30px
  margin: 0 auto
  position: relative
  .map-list
    margin-top: 16px
    commonBgColor(#1F2330, #FFFFFF)
    padding: 20px
    > p
      font-size: 12px
      commonColor(#BCBDC1, #999999)
      margin-top: 20px
      padding-left: 20px
  &-title
    font-size: 16px
    font-weight: 600
    padding-bottom: 10px
    commonColor(#ffffff, #333333)
    i
      color: #FC9C7C
      margin-right: 15px
  &-summary
    commonColor(#BCBDC1, #666666)
    font-size:14px
    line-height:22px
    margin-top: -3px
    padding-bottom: 7px
  &-content
    commonBgImg('~pic/watermark-white.png', '~pic/watermark-gray.png')
    .maps
      > div
        margin-top: 25px
        position: relative
        padding: 25px 0 10px 20px
        border-top: 1px solid
        commonBorderColor(#fa7a50, #FC9C7C)
        .map-title
          position: absolute
          font-size: 14px
          color: #fff
          commonBgColor(#fa7a50, #FC9C7C)
          left: 0
          top: -15px
          line-height: 30px
          padding: 0 16px
          white-space: nowrap
          &:before
            content: ''
            position: absolute
            height: 30px
            width: 11px
            background-size: 100% 100% !important
            commonBgImg('~pic/new_ele/t_right_d.png', '~pic/new_ele/t_right_l.png')
            top: 0
            right: -10px
        .logos
          margin: -6px -6px 0 0
          .ivu-tooltip
            display: inline-block
            vertical-align: top
            margin: 6px 6px 0 0
            cursor: pointer
            >>> .ivu-tooltip-arrow
              border-top-color: #404040
            >>> .ivu-tooltip-inner
              background-color: #404040
            &:hover
              commonShadow(2px 4px 20px 0px rgba(0,0,0,0.2), 2px 4px 20px 0px rgba(121,133,143,0.1))
          span.logo-span
            display: inline-block
            vertical-align: top
            background-color: #fff
            width: 90px
            height: 36px
            font-size: 0
            text-align: center
            line-height: 32px
            padding: 2px
            img
              max-width: 100%
              max-height: 100%
              vertical-align: middle
        .more
          color: rgba(250, 122, 80, 1)
          font-size: 12px
          display: table
          margin: 10px auto 0
          cursor: pointer
          &:hover
            color: #FC9C7C
          i
            font-size: 12px
            display: inline-block
            vertical-align: top
            margin-top: 1px
.spa
  position: absolute
  right: 20px
  bottom: 48px
  width: 18px
  height: 18px
  .iconfont
    font-size: 18px
    line-height: 1
    position: absolute
    right: 0
    top: 0
    commonColor(#CCCCCC, #CCCCCC)
    &:hover
      color: #63bf61 !important
  & >>> .ivu-poptip
    position: absolute
    width: 18px
    height: 18px
    .ivu-poptip-rel
      position: absolute
      width: 18px
      height: 18px
      right: 0
      top: 0
      cursor: pointer
    .ivu-poptip-popper
      transform: translate(13px, 0)
      .ivu-poptip-inner
        border-radius: 0
        .share_cnt
          padding: 10px 20px 10px 10px
          .share_img
            width: 80px
            height: 80px
            float: left
            background: #f0f0f0
          p
            line-height: 20px
            color: #666
            float: right
            margin-top: 20px
            font-size: 14px
</style>
